import { connect } from 'react-redux'
import DeleteUpdateActivity from './delete_update_activity'
import { deleteOrganizerUpdate } from '../../../../redux/modules/organizer_update'
import { show } from 'redux/modules/toast_notification'
import { TOAST_NOTIFICATIONS } from 'shared/shared_consts'

const mapStateToProps = state => ({
  showDeleteError: state.toast_notification[TOAST_NOTIFICATIONS.DELETE_ERROR],
})

const mapDispatchToProps = dispatch => {
  return {
    deleteOrganizerActivity(campaignId, id) {
      return dispatch(deleteOrganizerUpdate(campaignId, id))
    },
    onToggleToast(toastId, message) {
      dispatch(show(toastId, message))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteUpdateActivity)
